import { render } from "./flats-crm-items.vue?vue&type=template&id=0f3c0a1a"
import script from "./flats-crm-items.vue?vue&type=script&lang=js"
export * from "./flats-crm-items.vue?vue&type=script&lang=js"

import "./flats-crm-items.vue?vue&type=style&index=0&id=0f3c0a1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__